import { render, staticRenderFns } from "./SaleCardPriceSet.vue?vue&type=template&id=050dbf0c&scoped=true&"
import script from "./SaleCardPriceSet.vue?vue&type=script&lang=js&"
export * from "./SaleCardPriceSet.vue?vue&type=script&lang=js&"
import style0 from "./SaleCardPriceSet.vue?vue&type=style&index=0&id=050dbf0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050dbf0c",
  null
  
)

export default component.exports